import { AccessControlState } from "./types";

/**
 * Initial state for the Access Control module.
 * Starts with empty user lists and no active user.
 */
const state: AccessControlState = {
  auth0: {
    users: [],
    usersStatic: [],
    user: {},
    total: 0,
  },
};

export default state;
